import {
  createActions,
  createReqConsts,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'connection-room-join-req',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'p2p',
  type: 'post',
  slug: ['room_connection', 'join'],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/connection-room-join-req.js